import { useEffect, useState } from "react";
import "./index.css";
import { fetchConfig } from "./client/api";
import { Analyzer } from "./client/components/Analyzer";
import { Background } from "./client/components/Background";
import { Nav, type Tab } from "./client/components/Nav";
import { Wall } from "./client/components/Wall";

export function App() {
  const [tab, setTab] = useState<Tab>("wall");
  const [llmModel, setLlmModel] = useState("the model");

  useEffect(() => {
    fetchConfig()
      .then((c) => setLlmModel(c.llmModel))
      .catch(() => {});
  }, []);

  return (
    <>
      <Background />
      <Nav tab={tab} onChange={setTab} />
      <main>
        {tab === "wall" ? <Wall onOpenAnalyzer={() => setTab("analyzer")} /> : <Analyzer llmModel={llmModel} />}
      </main>
      <footer className="mono border-t-[1.5px] border-ink px-5 py-3 text-[10.5px] sm:px-8">
        <div className="mx-auto flex max-w-[1400px] flex-wrap justify-between gap-2">
          <span>FENZ.AI © 2026</span>
          <span className="opacity-55">prompt classification gateway</span>
        </div>
      </footer>
    </>
  );
}

export default App;
